export default "__VITE_ASSET__0T3cemUE__"